import script from "./AppActionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppActionCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppActionCard.vue?vue&type=style&index=0&id=8c09d7d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c09d7d4"]])

export default __exports__